import { useState } from "react";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { setProjectCategory } from "../../store/project/projectSlice";

export const CategoryDropdown = ({ onSave, onClose, className }) => {
  const { collections: categories } = useSelector((state) => state.templates);
  const { category } = useSelector((state) => state.project);
  const [showValidation, setShowValidation] = useState(false);
  const dispatch = useDispatch();

  const handleClose = () => {
    setShowValidation(false);
    return onClose();
  };

  const handleSave = () => {
    if (!category) {
      setShowValidation(true);
      return;
    }
    setShowValidation(false);
    return onSave();
  };
  return (
    <div className={`bg-gray-500/40 z-10 ml-0 ${className || ""}`}>
      <div
        className="z-10 border border-gray-600 shadow-lg shadow-lg overflow-hidden bg-gray-100 space-y-4 p-4"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex font-bold"> Select category </div>
        <div className="flex items-center">
          Category
          <select
            className="category-dropdown rounded-lg ml-4 border-solid border-black border-1 bg-white py-2"
            onChange={(e) => {
              dispatch(setProjectCategory(e.target.value));
              setShowValidation(false);
            }}
            value={category}
          >
            {(categories || []).map((category, index) => (
              <option key={index} value={category.id}>
                {category.name}
              </option>
            ))}
          </select>
        </div>
        {!!showValidation && (
          <label className="text-vb-violet">Please select the category</label>
        )}
        <div className="flex">
          <button
            className="bg-gray-600 text-white hover:bg-black
        hover:bg-black
        text-xs
        text-white
        font-bold
        mr-4
        ml-2
        py-2
        px-4
        rounded
        items-center
        w-full"
            onClick={handleSave}
          >
            Save
          </button>
          <button
            className="bg-gray-600 text-white hover:bg-black
        hover:bg-black
        text-xs
        text-white
        font-bold
        mr-4
        ml-2
        py-2
        px-4
        rounded
        items-center
        w-full"
            onClick={handleClose}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};
